/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ThrowErrorTestErrorGet$Params {
  errorType?: number;
}

export function throwErrorTestErrorGet(http: HttpClient, rootUrl: string, params?: ThrowErrorTestErrorGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, throwErrorTestErrorGet.PATH, 'get');
  if (params) {
    rb.query('errorType', params.errorType, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

throwErrorTestErrorGet.PATH = '/v1/ThrowError/TestErrorGet';
